import { render, staticRenderFns } from "./DistintaDiPrelievo.vue?vue&type=template&id=540cf9ec&scoped=true&"
import script from "./DistintaDiPrelievo.vue?vue&type=script&lang=js&"
export * from "./DistintaDiPrelievo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540cf9ec",
  null
  
)

export default component.exports